export enum ModalType {
  NONE = -1,
  SEARCH_BOOKS_IN_MEET = 1,
  SELECT_CLUB_PROFILE,
  SELECT_CLUB,
  ADD_CLUB_CONFIRM
}

export const defaultHeaderState = {
  title: '',
  subTitle: ''
}